import { Component, OnInit, Input, ViewChild, ElementRef, Output, EventEmitter, ComponentFactoryResolver } from '@angular/core';
import { FormControl } from '@angular/forms';
// Services';
import { FormService } from '../../../../../../services/form.service';
import { BroadcastService } from '@cv-invision/core';

@Component({
	selector: 'cv-schema-render-form-input',
	templateUrl: './input-field.component.html'
})
export class FormInputFieldComponent implements OnInit {
	@Input() fieldOptions: any;
	@Input() control: FormControl;
	@Input() field: any;
	@Input() value: any;
	@Input() historical: Array<any>;
	@Input() show: any;
	@Input() active = false;
	@Input() indexTab;
	@Output() openHistorical: EventEmitter<any> = new EventEmitter<any>();
	@Output() specialFieldEvent: EventEmitter<any> = new EventEmitter<any>();
	selectedDropdownValue: any;

	@ViewChild('changesEl', { read: ElementRef, static: false }) changesEl: ElementRef;

	highlight = '';
	temporalInputId = Date.now();
	keyCodes: number[] = [8, 38, 40, 189, 190, 109, 110];
	min: any;
	max: any;

	constructor(
		private broadcastService: BroadcastService,
		private formService: FormService
	) {
		//
	}

	ngOnInit(): any {
		if ('onlyDigits' in this.fieldOptions && this.fieldOptions.onlyDigits) {
			this.keyCodes = [8, 38, 40];
		}

		if ('min' in this.fieldOptions) {
			this.min = this.fieldOptions.min;
		}

		if ('max' in this.fieldOptions) {
			this.max = this.fieldOptions.max;
		}

	}

	/**
	 * validates form on input blur
	 * @param event
	 */
	async onChange(event: any): Promise<void> {
		if (this.control.parent) {
			// console.log(this.control.value);
			if (
				(['Text', 'String'].indexOf(this.field.DataType) > -1)
				&& this.control.value !== null
				&& this.control.value !== this.control.value.trim()
			) {
				this.control.setValue(this.control.value.trim());
			}

			if ((['Integer', 'Numeric'].indexOf(this.field.DataType) > -1)) {
				let number = parseFloat(this.control.value);
				if (this.max && number > this.max) {
					number = this.max;
				}

				this.control.setValue(number);
			}

			if (this.control.dirty || ['Enumerated', 'Boolean'].indexOf(this.field.DataType) > -1) {
				this.formService.validate(this.control);
				// await this.formService.update();
			}
		}
	}

	/**
	 * validates form on input keyup
	 * @param event
	 */
	async onKeyup(event: any): Promise<void> {
		if (this.control.parent) {
			if (this.control.dirty) {
				this.formService.validate(this.control);
				// await this.formService.update();
			}
		}
	}

	onKeyDownNumeric(event: any): boolean {
		if (event.keyCode === 9) {
			return true;
		}
		if (
			(event.keyCode > 95 && event.keyCode < 106) ||
			(event.keyCode > 47 && event.keyCode < 58) ||
			this.keyCodes.includes(event.keyCode)
		) {
			this.onKeyup(event);
			return true;
		}
		return false;
	}
	/**
	 * Cascader select update
	 * @param event
	 */
	cascadeChanged(event: any): void {
		// this.console.log(this.removeExcludesFromEnums);
		if (this.control.value !== event.Key) {
			this.control.setValue(event.Key);
			this.control.markAsDirty();
			this.onChange(event);
		}
	}

	/**
	 * open historical component
	 * @param item
	 * @param historical
	 */
	showHistorical(): void {
		this.openHistorical.emit(this.changesEl);
	}

	/**
	 * Set value for native boolean fields
	 * @param isSwitched
	 */
	onSwitchChange(isSwitched: boolean): void {
		if (this.control.value !== isSwitched) {
			this.control.setValue(isSwitched);
			this.control.markAsDirty();
			this.onChange(isSwitched);
		}
	}

	/**
	 * Event to set values in dropdown with associatd paths
	 * @param $event
	 */
	async selectedOption($event: any): Promise <void> {
		this.control.setValue($event ? $event[this.fieldOptions.optionValue] : '')
		this.control.markAsDirty();
		this.control.markAsTouched();

		if ('associtedPaths' in this.fieldOptions) {
			this.fieldOptions.associtedPaths.forEach((value: any) => {
				const newValue = $event ? $event[value.mapper] : '';
				const control = this.formService.form.get(value.path);
				if (control) {
					control.setValue(newValue);
					control.markAsDirty();
					control.markAsTouched();
				}
			});
		}

		this.onChange($event);
	}

	getSelectedDropDown(): void {
		if (this.fieldOptions.isDropdown) {
			const value = this.formService.form.get(this.fieldOptions.path).value;
			const indexDropdonwSelected = this.fieldOptions.listItems.findIndex((element: any) => element.name === value);
			if (indexDropdonwSelected >= 0) {
				this.selectedDropdownValue = this.fieldOptions.listItems[indexDropdonwSelected];
				this.value = this.selectedDropdownValue
				return this.selectedDropdownValue;
			}
		}
	}

}
